import { Partner } from "@/features/partners/models/partner";

const baseURL = import.meta.env.VITE_SERVER_API_URL;

function PartnerDiscount({
	partner,
	onPartnerClicked,
}: {
	partner: Partner;
	onPartnerClicked: (partner: Partner) => void;
}) {
	return (
		<div
			onClick={() => onPartnerClicked(partner)}
			className="bg-light flex h-37 w-full cursor-pointer items-center justify-center rounded-[32px]"
		>
			<img
				src={`${baseURL}/common/image/${partner.logoUrl}`}
				alt={partner.name}
				className="mb-2 h-20 w-20 object-contain"
			/>
		</div>
	);
}

export default PartnerDiscount;
